import React, { useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon, ArrowRightIcon, ArrowDownIcon, SmartphoneIcon, PhoneIcon, BellIcon, MailIcon, GlobeIcon, MessageSquareIcon, MapPinIcon, BarChart3Icon, UsersIcon, ShieldAlertIcon, Building2Icon, CalendarIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../components/LanguageContext';
import { trackEvent as track } from '../utils/analytics';
import { CommunicationsHero } from '../components/communications/CommunicationsHero';
import { CommunicationsChallenge } from '../components/communications/CommunicationsChallenge';
import { CommunicationsSolution } from '../components/communications/CommunicationsSolution';
import { CommunicationsAnalytics } from '../components/communications/CommunicationsAnalytics';
import { CommunicationsProof } from '../components/communications/CommunicationsProof';
import { CommunicationsFinalCTA } from '../components/communications/CommunicationsFinalCTA';
const reveal = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-80px'
  },
  transition: {
    duration: 0.7
  }
};
const COMPARISON_ROWS = [{
  traditional: 'Diffusion à une liste',
  traditionalEn: 'Broadcast to a list',
  bciti: 'Personnes vérifiées ciblées par localisation',
  bcitiEn: 'Verified people targeted by location'
}, {
  traditional: 'Un canal à la fois',
  traditionalEn: 'One channel at a time',
  bciti: 'SMS · Voix · Push · Courriel · Web · Réseaux sociaux coordonnés',
  bcitiEn: 'SMS · Voice · Push · Email · Web · Social coordinated'
}, {
  traditional: 'Envoyé',
  traditionalEn: 'Sent',
  bciti: 'Livré et mesurable',
  bcitiEn: 'Delivered and measurable'
}, {
  traditional: 'Outil d\u2019urgence isolé',
  traditionalEn: 'Standalone emergency tool',
  bciti: 'Mêmes rails pour les communications d\u2019urgence et quotidiennes',
  bcitiEn: 'Same rails for emergency and daily communications'
}, {
  traditional: 'Mises à jour manuelles des audiences',
  traditionalEn: 'Manual audience updates',
  bciti: 'Mises à jour d\u2019audiences propulsées par l\u2019identité',
  bcitiEn: 'Identity-powered audience updates'
}, {
  traditional: 'Contacts anonymes',
  traditionalEn: 'Anonymous contacts',
  bciti: 'Identités vérifiées',
  bcitiEn: 'Verified identities'
}];
const WORKFLOW = [{
  fr: 'Urgence',
  en: 'Emergency'
}, {
  fr: 'Avis de service',
  en: 'Service Notice'
}, {
  fr: 'Rappel',
  en: 'Reminder'
}, {
  fr: 'Renouvellement',
  en: 'Renewal'
}, {
  fr: 'Engagement',
  en: 'Engagement'
}];
export function Communications() {
  const {
    lang
  } = useLanguage();
  useEffect(() => {
    track('Page Viewed', {
      page: 'Communications'
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-8242" data-mp="2fsy45jrb67qo">
      <Header data-id="element-8243" data-mp="2frdcq30aj4x1" />

      <main className="pt-[120px]" data-id="element-8244" data-mp="46e47qwbm5dy">
        {/* SECTION 1: HERO */}
        <CommunicationsHero data-id="element-8245" data-mp="47p8drtohf5l" />

        {/* SECTION 2: LE DÉFI */}
        <section className="py-20 lg:py-24 px-6 border-t border-[#E4E6EC] bg-white overflow-hidden" data-id="element-8246" data-mp="3vbnnz0tq1nf4">
          <CommunicationsChallenge data-id="element-8247" data-mp="3qenml37th8uc" />
        </section>

        {/* SECTION 3: LA SOLUTION */}
        <section className="py-20 lg:py-24 px-6 border-t border-[#E4E6EC] bg-[#FCFCFE] overflow-hidden" data-id="element-8248" data-mp="3lfko61mce0vc">
          <CommunicationsSolution data-id="element-8249" data-mp="mvki90m668tf" />
        </section>

        {/* SECTION 4: L'ANALYTIQUE */}
        <section className="py-20 lg:py-24 px-6 border-t border-[#E4E6EC] bg-white overflow-hidden" data-id="element-8250" data-mp="hyu3qhq0jla4">
          <CommunicationsAnalytics data-id="element-8251" data-mp="d610xze3un0o" />
        </section>

        {/* SECTION 5: RÉSULTATS EN PRODUCTION */}
        <section className="py-20 lg:py-24 px-6 border-t border-[#E4E6EC] bg-[#FCFCFE] overflow-hidden" data-id="element-8252" data-mp="877wewgsq6cn">
          <CommunicationsProof data-id="element-8253" data-mp="15oy6kmvdnh02" />
        </section>

        {/* FINAL CTA */}
        <section id="contact" className="py-20 lg:py-24 px-6 border-t border-[#E4E6EC] bg-white overflow-hidden scroll-mt-24" data-id="element-8254" data-mp="10vlv7efpl6p9">
          <CommunicationsFinalCTA data-id="element-8255" data-mp="ldc4zkq1treh" />
        </section>

      </main>

      <Footer data-id="element-8256" data-mp="qe03erglxaiq" />
    </div>;
}